import React from "react";
import { useSelector } from "react-redux";

import { InternalButton } from "@components/shared/buttons";

import ZendeskIconHideWrapper from "@stadium/services/zendesk/icon-hide-wrapper";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  ModalHeader,
  ModalContent,
  ModalDialog,
  CloseButton,
  ModalFooter,
  ModalBody,
} from "@stadium/ui/src/components/ModalNew/utils";

import useManipulateCartProduct from "@hooks/cart/use-manipulate-cart-product";

import { getCartOrderId } from "@store/selectors/cart";

import styles from "./main.module.scss";

const EmptyWorkspaceCartModal = ({ onSuccess, closeModal }) => {
  const orderId = useSelector(getCartOrderId);

  const { emptyingCart, removeAllProductsFromCart } = useManipulateCartProduct({
    emptyCartSuccessCb: onSuccess,
  });

  return (
    <ZendeskIconHideWrapper>
      <Modal
        closeModal={closeModal}
        newModal
        mobileBottomDrawer
        className={styles.modalChangeWorkspace}
      >
        <ModalDialog className={styles.modalDialog}>
          <ModalContent>
            <ModalHeader className={styles.modalHeader}>
              <div className={styles.modalHeaderTitle}>Change Workspace?</div>
              <CloseButton onClick={closeModal} />
            </ModalHeader>
            <ModalBody className={styles.modalBody}>
              If you change your Workspace, your bag will be emptied and you'll have to select your
              items again to check out.
            </ModalBody>
            <ModalFooter className={styles.modalFooter}>
              <InternalButton
                styleType="primary-outline"
                onClick={closeModal}
                className={styles.btnCancel}
                innerChildClass={styles.buttonLabel}
              >
                Cancel
              </InternalButton>
              <InternalButton
                styleType="primary"
                onClick={() => removeAllProductsFromCart(orderId)}
                isLoading={emptyingCart}
                className={styles.btnConfirm}
                innerChildClass={styles.buttonLabel}
              >
                Confirm
              </InternalButton>
            </ModalFooter>
          </ModalContent>
        </ModalDialog>
      </Modal>
    </ZendeskIconHideWrapper>
  );
};

export default EmptyWorkspaceCartModal;
